module.exports = __webpack_public_path__ + "img/digital_3d.46cdaf87.png";